import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-btn-nuevo-banco',
  templateUrl: './btn-nuevo-banco.component.html',
  styleUrls: ['./btn-nuevo-banco.component.css']
})
export class BtnNuevoBancoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
